<template>
  <section class="page-stack">
    <div class="page-intro"><div><p class="eyebrow">DATA INTELLIGENCE</p><h2>数据中心</h2><p>以成功消费订单为准，观察公会等级和主播经营趋势。</p></div><el-select v-model="months" @change="loadSummary"><el-option label="近 3 个月" :value="3" /><el-option label="近 6 个月" :value="6" /><el-option label="近 12 个月" :value="12" /></el-select></div>
    <article class="panel chart-panel" v-loading="summaryLoading">
      <div class="panel-head"><div><p class="eyebrow">MONTHLY TREND</p><h3>真实流水趋势</h3></div><span class="legend"><i /> 成功消费金币</span></div>
      <div class="bar-chart">
        <div v-for="item in trend" :key="item.period_month" class="bar-item"><div class="bar-value">{{ compact(item.gross_coin_amount) }}</div><div class="bar-track"><span :style="{ height: barHeight(item.gross_coin_amount) }" /></div><small>{{ item.period_month }}</small></div>
      </div>
    </article>
    <article class="panel">
      <div class="panel-head"><div><p class="eyebrow">ORDER LEDGER</p><h3>真实收入明细</h3></div><el-date-picker v-model="month" type="month" value-format="yyyy-MM" placeholder="选择月份" @change="searchIncome" /></div>
      <el-table v-loading="loading" :data="rows">
        <el-table-column prop="trade_no" label="交易编号" min-width="190" />
        <el-table-column prop="author_name" label="主播" min-width="130" />
        <el-table-column label="收入类型" width="110"><template slot-scope="{ row }">{{ incomeType(row.income_type) }}</template></el-table-column>
        <el-table-column prop="item_name" label="消费内容" min-width="180" show-overflow-tooltip />
        <el-table-column label="成功消费" width="150"><template slot-scope="{ row }"><strong class="coin-value">{{ format(row.coin_amount) }}</strong> 金币</template></el-table-column>
        <el-table-column prop="create_time" label="发生时间（UTC）" width="175" />
      </el-table>
      <table-pager :total="count" :page="page" :limit="limit" @page-change="changePage" @limit-change="changeLimit" />
    </article>
  </section>
</template>
<script>
import { analyticsSummaryGet, incomeListGet } from "../api/guild"
import TablePager from "../components/TablePager.vue"
export default {
  name: "AnalyticsView",
  components: { TablePager },
  data: () => ({ months: 6, trend: [], summaryLoading: false, month: new Date().toISOString().slice(0, 7), rows: [], count: 0, page: 1, limit: 20, loading: false }),
  created() { this.loadSummary(); this.loadIncome() },
  computed: { maxValue() { return Math.max(1, ...this.trend.map(item => Number(item.gross_coin_amount || 0))) } },
  methods: {
    async loadSummary() { this.summaryLoading = true; try { const res = await analyticsSummaryGet({ months: this.months }); this.trend = res.data.trend } finally { this.summaryLoading = false } },
    async loadIncome() { this.loading = true; try { const res = await incomeListGet({ month: this.month, page: this.page, limit: this.limit }); this.rows = res.data.data; this.count = Number(res.data.count) } finally { this.loading = false } },
    searchIncome() { this.page = 1; this.loadIncome() },
    changePage(page) { this.page = page; this.loadIncome() },
    changeLimit(limit) { this.limit = limit; this.page = 1; this.loadIncome() },
    barHeight(value) { return `${Math.max(5, Math.round(Number(value || 0) / this.maxValue * 100))}%` },
    format(value) { return new Intl.NumberFormat("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value || 0)) },
    compact(value) { return new Intl.NumberFormat("zh-CN", { notation: "compact", maximumFractionDigits: 1 }).format(Number(value || 0)) },
    incomeType(type) { return { gift: "直播礼物", tip: "投喂", paid: "付费内容" }[type] || type }
  }
}
</script>
